export default "__VITE_ASSET__d394d58e__"